const data_CN = {
  topPage: {
    rightImg: require("@/assets/productServices/brandOperation/pic_bo.png"),
    englishName: 'BRAND OPERATION',
    name: '品牌运营',
    introText: '专注于国内&国际商务领域，帮助品牌在日本和全球市场拓宽知名度和提升销量，与保持长期合作关系。',
    serviceInclude: '服务内容涵盖:',
    bottomImg: true,
    frontIntroText: 'OFFSHORE',
    endIntroText: '品牌战略咨询、市场调研和分析、品牌定位与运营、市场进入策略、管理创新、渠道伙伴引入。'
  },
  serviceContent: {
    title: '服务内容',
    list: [
      {
        titleEn: 'Consulting',
        title: '品牌战略咨询',
        content: '覆盖商业全生命周期的品牌/企业战略发展咨询，不论您是大型企业或初创企业，甚至还没有正式开始，我们都将助力您的价值变现。',
        bgImage: require("@/assets/productServices/brandOperation/serviceContent/number_01@2x.png"),
        mainImage: require("@/assets/productServices/brandOperation/serviceContent/pic_coop01@2x.png")
      },
      {
        titleEn: 'Research',
        title: '市场调研和分析',
        content: '基于商业智能对全球大数据的分析能力，向您展示市场的机会线索与商业可行性策略，专业的顾问团队将会对您的市场发展策略及时给到调整意见，确保您的商业无惧风险。',
        bgImage: require("@/assets/productServices/brandOperation/serviceContent/number_02@2x.png"),
        mainImage: require("@/assets/productServices/brandOperation/serviceContent/pic_coop02@2x.png")
      },
      {
        titleEn: 'Branding',
        title: '品牌定位与运营',
        content: 'Offshore深谙商务属性的视觉调性和拍摄节奏，具备精良的制片、摄影、摄像、后期团队，可根据品牌客户需求，定制创意视觉，提供创意策划、拍摄团队、妆容、造型、道具、场景搭建等服务。',
        bgImage: require("@/assets/productServices/brandOperation/serviceContent/number_03@2x.png"),
        mainImage: require("@/assets/productServices/brandOperation/serviceContent/pic_coop03@2x.png")
      },
      {
        titleEn: 'Strategy',
        title: '市场进入策略',
        content: '基于全球商务渠道整合能力，Offshore可提供多渠道市场进入策略指导及渠道引入策略等。',
        bgImage: require("@/assets/productServices/brandOperation/serviceContent/number_04@2x.png"),
        mainImage: require("@/assets/productServices/brandOperation/serviceContent/pic_coop04@2x.png")
      },
      {
        titleEn: 'Management',
        title: '管理创新',
        content: '让您专注于生意，而我们来执行。只有一个idea？不用怕！我们将为您完成infra基础设施建设（包含办公设施采买租赁、名片物料等制作、全渠道整合宣传、商业计划书编写提交等）',
        bgImage: require("@/assets/productServices/brandOperation/serviceContent/number_05@2x.png"),
        mainImage: require("@/assets/productServices/brandOperation/serviceContent/pic_coop05@2x.png")
      },
      {
        titleEn: 'Partner',
        title: '渠道伙伴引入',
        content: 'Offshore覆盖全日本/全球的渠道、合作伙伴矩阵，让生意易如反掌，总是快人一步！',
        bgImage: require("@/assets/productServices/brandOperation/serviceContent/number_06@2x.png"),
        mainImage: require("@/assets/productServices/brandOperation/serviceContent/pic_coop06@2x.png")
      }
    ]
  }
}

const data_JA = {
  topPage: {
    rightImg: require("@/assets/productServices/brandOperation/pic_bo.png"),
    englishName: 'BRAND OPERATION',
    name: 'ブランド運営',
    introText: '国内外のビジネスフィールドに焦点を当て、ブランドが日本および世界市場で人気を拡大し、売上を増加させ、ブランドとの長期的な協力関係を維持するのを支援します。',
    serviceInclude: 'サービス内容は:',
    bottomImg: true,
    frontIntroText: 'オフショアは',
    endIntroText: 'ブランド戦略コンサルティング、市場調査・分析、ブランドポジショニングと運営、市場参入戦略、経営革新、チャネルパートナー紹介など。'
  },
  serviceContent: {
    title: 'サービス内容',
    list: [
      {
        titleEn: 'Consulting',
        title: 'ブランド戦略コンサルティング',
        content: '大企業からスタートアップ企業、まだ正式にスタートしていない企業まで、ビジネスライフサイクル全体をカバーするブランド・企業戦略策定コンサルティングで、貴社の価値実現をお手伝いします。',
        bgImage: require("@/assets/productServices/brandOperation/serviceContent/number_01@2x.png"),
        mainImage: require("@/assets/productServices/brandOperation/serviceContent/pic_coop01@2x.png")
      },
      {
        titleEn: 'Research',
        title: '市場調査と分析',
        content: 'グローバルビッグデータを分析するビジネスインテリジェンスの能力に基づいて、市場機会の手がかりと商業的実現可能性戦略を示し、専門のコンサルタントチームが市場開発戦略についてタイムリーに調整意見を提供し、貴社のビジネスがリスクを恐れないようにします。',
        bgImage: require("@/assets/productServices/brandOperation/serviceContent/number_02@2x.png"),
        mainImage: require("@/assets/productServices/brandOperation/serviceContent/pic_coop02@2x.png")
      },
      {
        titleEn: 'Branding',
        title: 'ブランドの方針と運営',
        content: 'Offshore は、ビジネス属性の視覚的な色調と撮影リズムに精通しており、優れた制作、写真、ビデオ撮影、ポストプロダクション チームを擁し、ブランド顧客のニーズに合わせてクリエイティブ ビジョンをカスタマイズし、クリエイティブ プランニング、撮影チームを提供できます。 、メイクアップ、モデリング、小道具、シーン、建設およびその他のサービス。',
        bgImage: require("@/assets/productServices/brandOperation/serviceContent/number_03@2x.png"),
        mainImage: require("@/assets/productServices/brandOperation/serviceContent/pic_coop03@2x.png")
      },
      {
        titleEn: 'Strategy',
        title: '市場参入戦略',
        content: 'Offshore は、グローバル ビジネス チャネルを統合する能力に基づいて、マルチチャネル市場参入戦略のガイダンスとチャネル導入戦略を提供できます。',
        bgImage: require("@/assets/productServices/brandOperation/serviceContent/number_04@2x.png"),
        mainImage: require("@/assets/productServices/brandOperation/serviceContent/pic_coop04@2x.png")
      },
      {
        titleEn: 'Management',
        title: '経営革新',
        content: 'ビジネスに専念させます。私たちがあなたの仕事を推進してあげましょう。あなたはただ1つのアイデアを提供して、私たちはあなたのために製品開発の関連プロセス（商業計画書の作成と提出、開発設備の購入賃貸、会社と製品の関連設計制作（公式サイト/電子商取引/ロゴなどの美術設計）、全ルートの統合宣伝などを含む）を組織します',
        bgImage: require("@/assets/productServices/brandOperation/serviceContent/number_05@2x.png"),
        mainImage: require("@/assets/productServices/brandOperation/serviceContent/pic_coop05@2x.png")
      },
      {
        titleEn: 'Partner',
        title: 'チャネルパートナーの紹介',
        content: 'オフショアは日本/グローバルのすべてのチャネルとパートナー マトリックスをカバーし、ビジネスを容易にし、常に一歩先を行きます。',
        bgImage: require("@/assets/productServices/brandOperation/serviceContent/number_06@2x.png"),
        mainImage: require("@/assets/productServices/brandOperation/serviceContent/pic_coop06@2x.png")
      }
    ]
  }
}

const data_EN = {
  topPage: {
    rightImg: require("@/assets/productServices/brandOperation/pic_bo.png"),
    englishName: 'BRAND OPERATION',
    name: 'Brand Operation',
    introText: ' focuses on domestic & international business fields, helping brands expand their popularity and increase sales in Japan and the global market, and maintain long-term cooperative relationships with them.',
    serviceInclude: 'Service content covers:',
    bottomImg: true,
    frontIntroText: 'OFFSHORE',
    endIntroText: ' brand strategy consulting, market research and analysis, brand positioning and operation, market entry strategy, management innovation, channel partner introduction.'
  },
  serviceContent: {
    title: 'Service Content',
    list: [
      {
        titleEn: 'Consulting',
        title: 'Brand Strategy Consulting',
        content: 'Brand/corporate strategy development consulting covering the entire business life cycle, whether you are a large enterprise or a start-up, or you have not even officially started, we will help you realize your value.',
        bgImage: require("@/assets/productServices/brandOperation/serviceContent/number_01@2x.png"),
        mainImage: require("@/assets/productServices/brandOperation/serviceContent/pic_coop01@2x.png")
      },
      {
        titleEn: 'Research',
        title: 'Market Research and Analysis',
        content: 'Based on the ability of business intelligence to analyze global big data, it will show you market opportunity clues and commercial feasibility strategies. The professional consultant team will give you timely adjustment opinions on your market development strategy to ensure that your business is not afraid of risks.',
        bgImage: require("@/assets/productServices/brandOperation/serviceContent/number_02@2x.png"),
        mainImage: require("@/assets/productServices/brandOperation/serviceContent/pic_coop02@2x.png")
      },
      {
        titleEn: 'Branding',
        title: 'Brand positioning and operation',
        content: 'Offshore is well versed in the visual tonality and shooting rhythm of business attributes. It has excellent production, photography, videography, and post-production teams. It can customize creative vision according to the needs of brand customers, and provide creative planning, shooting teams, makeup, modeling, props, and scenes. Construction and other services.',
        bgImage: require("@/assets/productServices/brandOperation/serviceContent/number_03@2x.png"),
        mainImage: require("@/assets/productServices/brandOperation/serviceContent/pic_coop03@2x.png")
      },
      {
        titleEn: 'Strategy',
        title: 'Market entry strategy',
        content: 'Based on the ability to integrate global business channels, Offshore can provide multi-channel market entry strategy guidance and channel introduction strategies.',
        bgImage: require("@/assets/productServices/brandOperation/serviceContent/number_04@2x.png"),
        mainImage: require("@/assets/productServices/brandOperation/serviceContent/pic_coop04@2x.png")
      },
      {
        titleEn: 'Management',
        title: 'Management innovation',
        content: 'Let you focus on your business while we execute. Only one idea? do not be afraid! We will complete infra infrastructure construction for you (including purchase and lease of office facilities, production of business card materials, etc., omni-channel integrated publicity, business plan preparation and submission, etc.)',
        bgImage: require("@/assets/productServices/brandOperation/serviceContent/number_05@2x.png"),
        mainImage: require("@/assets/productServices/brandOperation/serviceContent/pic_coop05@2x.png")
      },
      {
        title: 'Channel partner introduction',
        content: 'Offshore covers all Japan/global channels and partner matrix, making business easy and always one step ahead!',
        bgImage: require("@/assets/productServices/brandOperation/serviceContent/number_06@2x.png"),
        mainImage: require("@/assets/productServices/brandOperation/serviceContent/pic_coop06@2x.png")
      }
    ]
  }
}

export default {
  data_CN,
  data_JA,
  data_EN
}


// WEBPACK FOOTER //
// ./src/common/json/brandOperation.js